import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const ErrorInfoWrapper = styled.div`
  margin-top: ${Spacing.S4};
`
